module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "80",
      "desktop": "50",
      "tablet": "70"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-time-picker', {
    attrs: {
      "label": _vm.$t('message.labelTime'),
      "mode": "portrait",
      "fullWidth": "",
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText')
    },
    model: {
      value: (_vm.timeModel.time),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "time", $$v)
      },
      expression: "timeModel.time"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "label": _vm.$t('message.labelDate'),
      "okLabel": _vm.$t('message.okText'),
      "cancelLabel": _vm.$t('message.cancelText'),
      "dateTimeFormat": _vm.dateFormat,
      "format": "DD-MM-YYYY",
      "maxDate": _vm.maxDate,
      "fullWidth": ""
    },
    model: {
      value: (_vm.timeModel.date),
      callback: function($$v) {
        _vm.$set(_vm.timeModel, "date", $$v)
      },
      expression: "timeModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', [(_vm.preference === 'kg') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:635',
      "data-vv-name": "kg",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('kg'),
      "type": "number",
      "label": "KG",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.kg),
      callback: function($$v) {
        _vm.$set(_vm.reading, "kg", _vm._n($$v))
      },
      expression: "reading.kg"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:750',
      "data-vv-name": "lbs",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('lbs'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.lbs),
      callback: function($$v) {
        _vm.$set(_vm.reading, "lbs", _vm._n($$v))
      },
      expression: "reading.lbs"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required|min_value:0|max_value:100',
      "data-vv-name": "stones",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('stones'),
      "type": "number",
      "label": "ST",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.stones),
      callback: function($$v) {
        _vm.$set(_vm.reading, "stones", _vm._n($$v))
      },
      expression: "reading.stones"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.preference === 'st-lbs') ? _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-rules": 'required|min_value:0|max_value:13',
      "data-vv-name": "pounds",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('pounds'),
      "type": "number",
      "label": "LBS",
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": true
    },
    model: {
      value: (_vm.reading.pounds),
      callback: function($$v) {
        _vm.$set(_vm.reading, "pounds", _vm._n($$v))
      },
      expression: "reading.pounds"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditMode(_vm.reading)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isUpdating,
      "label": _vm.isUpdating ? _vm.$t('message.updatingText') : _vm.$t('message.updateText'),
      "type": "button",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03cf59fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Edit/Weight/WeightEdit.vue
// module id = 3581
// module chunks = 1